import { FREE, AIS } from "../../util/enumTypes";

export default {
  computed: {},
  data() {
    return {};
  },
  methods: {
    getNameOfDistanceForHotelMixins(hotelId) {
      let nameDistanceObject = this.$t("search_form_place_center");
      let searchHotelId = this.$store.state.HotelStorage.params.hotel;

      if (this.$store.state.HotelStorage.params.alternative) {
        nameDistanceObject =
          !searchHotelId || searchHotelId == hotelId
            ? this.$t("search_form_place_center")
            : this.$t("search_form_place_object");
      }
      return nameDistanceObject;
    },
    getStatusServiceMixins(service) {
      let status = "";
      if (service != null) {
        status = service.status;
        if (status == FREE && service.source == AIS) {
          status = service.statusCalc;
        }
      }
      return status;
    },
    getStatusStyle(places) {
      return {
        color:
          places && this.getStatusService(places) != "request" ? "#67c23a" : ""
      };
    },
    getStatusName(places) {
      let status = this.getStatusService(places);
      return status == "free"
        ? this.$t("search_result_free")
        : status == "online"
        ? this.$t("search_result_online")
        : this.$t("search_result_request");
    }
  }
};
